import { Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import MarkdownToHtml from '../../MarkdownToHtml';

const classes = {
  success: 'text-green-600',
  successBlue: 'text-blue-500',
  danger: 'text-red-600',
  default: 'text-gray-600',
  warning: 'text-orange-600',
  theme: 'text-theme',
  themeWithBg: 'text-theme bg-theme bg-opacity-25 px-2 py-1 font-bold text-sm rounded-lg',
};

const getClasses = (level, inline, className) =>
  clsx(classes[level], 'font-normal', inline && 'inline', className);

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    maxWidth: '350px',
  },
  arrow: {
    color: theme.palette.common.white,
  },
}))(Tooltip);

const RefreshButton = ({
  icon,
  level,
  inline,
  doShow,
  descriptionOnHover,
  tooltipPlacement,
  className,
  click,
  doShowLoadingState,
  disabled,
}) => {
  if (!doShow) return null;

  const renderContent = (
    <button
      type="button"
      className={clsx(
        getClasses(level, inline, className),
        'leading-4 flex gap-1 items-center',
        click && 'cursor-pointer',
        (doShowLoadingState || disabled) && 'cursor-not-allowed opacity-50',
        'focus:outline-none',
      )}
      onClick={click}
      disabled={doShowLoadingState || !click || disabled}
    >
      {doShowLoadingState ? (
        <svg
          className="animate-spin ml-2 h-5 w-5 inline-block"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      ) : (
        icon &&
        React.cloneElement(icon, {
          className: `inline-block ${(icon.props && icon.props.className) || ''}`,
        })
      )}
    </button>
  );

  if (descriptionOnHover) {
    return (
      <LightTooltip
        title={
          typeof descriptionOnHover === 'string' ? (
            <MarkdownToHtml
              content={descriptionOnHover}
              className="text-xs font-normal text-black"
            />
          ) : (
            descriptionOnHover
          )
        }
        placement={tooltipPlacement}
        arrow
      >
        {renderContent}
      </LightTooltip>
    );
  }

  return renderContent;
};

RefreshButton.propTypes = {
  icon: PropTypes.node,
  level: PropTypes.string,
  inline: PropTypes.bool,
  doShow: PropTypes.bool,
  descriptionOnHover: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltipPlacement: PropTypes.string,
  className: PropTypes.string,
  click: PropTypes.func,
  doShowLoadingState: PropTypes.bool,
};

RefreshButton.defaultProps = {
  level: 'default',
  inline: false,
  icon: undefined,
  doShow: true,
  descriptionOnHover: undefined,
  tooltipPlacement: undefined,
  className: '',
  click: undefined,
  doShowLoadingState: false,
};

export default RefreshButton;
